import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { labelsService } from '@/services/labels.service';
import type { LabelOption } from '@/types/labels';

export interface UseLabelOptionsParams {
  q?: string;
  limit?: number;
  enabled?: boolean;
  /** Keep previous results visible while a new query loads */
  keepPrevious?: boolean;
}

export const labelOptionsKey = (q?: string, limit?: number) =>
  ['labels', 'options', q ?? '', limit ?? null] as const;

/**
 * Canonical label options (picker / filter / autocomplete).
 * Backed by GET /api/labels/options.
 */
export const useLabelOptions = ({ q, limit, enabled = true, keepPrevious = false }: UseLabelOptionsParams = {}) =>
  useQuery<LabelOption[], Error>({
    queryKey: labelOptionsKey(q, limit),
    queryFn: () => labelsService.getOptions({ q, limit }),
    enabled,
    placeholderData: keepPrevious ? keepPreviousData : undefined,
    staleTime: 60 * 1000,
  });
